import Vue from 'vue'
import VueRouter from 'vue-router'
import middlewareProcessor from '../middlewares/processor'

import routes from './routes'

Vue.use(VueRouter)

const Router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes,
  mode: process.env.VUE_ROUTER_MODE,
  base: process.env.VUE_ROUTER_BASE
})

Router.beforeEach(middlewareProcessor)

export default Router
